export class IUTM {
  constructor() {
    this.id = null;
    this.n = null;
    this.e = null;
    this.module = {};
    this.submodule = {};
  }
}
